import styled, { css } from 'styled-components'
import { SIZES } from '~/common/globalStyles'

export const DrawerHeaderDescription = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing(1)};
  font-size: ${SIZES.medium};
`

export const DrawerHeaderContainer = styled.div(
  ({ theme }) => `
  padding: ${theme.name === 'lightV2' ? theme.spacing(2) : theme.spacing(3)};
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${theme.palette.lighterGray};
`,
)

export const DrawerHeaderTitle = styled.div(
  ({ theme }) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${theme.spacing(3)};
`,
)

export const DrawerHeaderSubtitle = styled.div(
  ({ theme }) => `
  color: ${theme.palette.text.secondary};
  font-size: 13px;
  line-height: 18px;
  padding-top: 6px;
  text-transform: uppercase;
  letter-spacing: 2px; 
`,
)

interface DrawerHeaderIconStyleProps {
  imageUrl: string
}

export const DrawerHeaderIcon = styled.div<DrawerHeaderIconStyleProps>(
  ({ theme, imageUrl }) => `
    ${
      imageUrl &&
      css`
        height: 23px;
        width: 23px;
        background-image: url(${imageUrl});
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        border-color: ${theme.palette.lighterGray};
        background-color: ${theme.palette.white};
        margin-right: ${theme.spacing(2)};
      `
    };
`,
)

export const DrawerHeaderContainerAssign = styled.div(
  ({ theme }) => `
  padding: ${theme.name === 'lightV2' ? theme.spacing(2) : theme.spacing(3)};
  padding-bottom: ${
    theme.name === 'lightV2' ? theme.spacing(1.5) : theme.spacing(2)
  }px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${theme.name === 'lightV2' ? theme.spacing(2) : theme.spacing(3)};
`,
)

export const DrawerHeaderAssignTask = styled.div(
  ({ theme }) => `
  font-size: ${theme.spacing(3)};
  color: ${theme.palette.grey[800]};
  font-weight: bold;
`,
)

export const DrawerHeaderProjectData = styled.div(
  ({ theme }) => `
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${theme.palette.grey[500]};
`,
)

export const DrawerHeaderDataContainer = styled.div(
  ({ theme }) => `
display: grid;
grid-template-columns: 1fr 1fr;
grid-gap: ${theme.name === 'lightV2' ? theme.spacing(1) : theme.spacing(2)};
font-size: ${theme.name === 'lightV2' ? theme.spacing(1.5) : theme.spacing(2)};
margin-top: ${theme.name === 'lightV2' ? theme.spacing(0.5) : theme.spacing(1)};
`,
)
